import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  denyConsent,
  getStoredConsent,
  grantConsent,
  loadGa,
  setStoredConsent,
  trackPageView,
} from "@/lib/ga";

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getStoredConsent() === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    setStoredConsent("granted");
    grantConsent();
    loadGa();
    trackPageView(window.location.pathname);
    setVisible(false);
  };

  const handleDecline = () => {
    setStoredConsent("denied");
    denyConsent();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-3 bottom-20 lg:bottom-4 lg:left-auto lg:right-4 lg:max-w-md z-50 rounded-lg border border-brass/30 bg-charcoal/95 backdrop-blur shadow-[0_10px_40px_-10px_rgba(0,0,0,0.6)]"
    >
      <div className="p-4 md:p-5">
        <div className="text-[10px] uppercase tracking-[0.25em] text-warm-white/55 mb-2">
          Privacy
        </div>
        <p className="text-sm text-warm-white/80 leading-relaxed">
          We use cookies to measure site traffic with Google Analytics. No personal info is sold.
        </p>
        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          <Button variant="brass" size="sm" onClick={handleAccept} className="flex-1">
            Accept
          </Button>
          <Button variant="outlineLight" size="sm" onClick={handleDecline} className="flex-1">
            Decline
          </Button>
        </div>
      </div>
    </div>
  );
};
